import { FC, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import StepTwo from './StepTwo';
import StepThree from './StepThree';
import StepFour from './StepFour';
import StepFive from './StepFive';
import ConfettiExplosion from 'react-confetti-explosion';
import { Steps as StepsDesktop } from 'antd';

export function useIsMobile() {
  const [isMobile, setIsMobile] = useState(
    typeof window !== 'undefined' ? window.innerWidth < 768 : false
  );

  useEffect(() => {
    const handleResize = () => {
      const isNowMobile = window.innerWidth < 768;
      setIsMobile((prev) => {
        if (prev !== isNowMobile) return isNowMobile;
        return prev;
      });
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return isMobile;
}

const OnboardingPage: FC = () => {
  const [step, setStep] = useState(1);
  const isMobile = useIsMobile();

  const onPreviousHandler = () => {
    if (step > 1) {
      setStep(step - 1);
    }
  };

  const onNextHandler = () => {
    setStep(step + 1);
  };

  return (
    <div className="relative flex min-h-[100vh] flex-col">
      <div className="sticky left-0 top-0 z-10 mt-0 w-full bg-[#0044CC] pt-0 shadow-sm">
        <div className="mx-auto flex h-12 w-full max-w-[1920px] items-center justify-between gap-4 px-4 sm:px-6 lg:px-8">
          <Link
            className="flex flex-none items-center justify-center rounded-full pt-1.5 font-zephyr text-3xl leading-none text-primary max-md:aspect-square max-md:w-10 max-md:bg-white md:text-white"
            to="/dashboard"
          >
            <span className="max-md:hidden">lionshare</span>
            <span className="md:hidden">ls</span>
          </Link>

          <Link to="/dashboard" style={{ color: 'white' }}>
            Skip to dashboard
          </Link>
        </div>
      </div>

      <div
        className={`relative mx-auto flex min-h-[calc(100vh-50px)] w-full flex-col items-center justify-between gap-12 p-6`}
        style={{ maxWidth: 720 }}
      >
        <div />

        {step === 1 && (
          <StepTwo previous={onPreviousHandler} next={onNextHandler} />
        )}

        {step === 2 && (
          <StepThree previous={onPreviousHandler} next={onNextHandler} />
        )}

        {step === 3 && (
          <StepFour previous={onPreviousHandler} next={onNextHandler} />
        )}

        {step === 4 && (
          <div>
            <StepFive />
            <ConfettiExplosion
              force={0.8}
              duration={3000}
              particleCount={300}
              width={1600}
              colors={['#041E43', '#1471BF', '#5BB4DC', '#FC027B', '#66D805']}
            />
          </div>
        )}

        <div className="flex items-center justify-between max-md:max-w-[342px]">
          <StepsDesktop
            progressDot
            size="small"
            current={step - 1}
            direction="horizontal"
            className="w-full [&_.ant-steps-item]:min-w-0 [&_.ant-steps-item]:flex-1"
            responsive={false}
            items={[
              { title: isMobile && step !== 1 ? '' : 'Connect your accounts' },
              { title: isMobile && step !== 2 ? '' : 'Quick form' },
              { title: isMobile && step !== 3 ? '' : 'Team invite' },
              { title: isMobile && step !== 4 ? '' : "You're all set" },
            ]}
          />
        </div>
      </div>
    </div>
  );
};

export default OnboardingPage;
